export const Props = () => ({
  //Данные для инициализации
  initData: {
    type: Object,
    required: false,
  }
});